import {
    SAVE_TASK, TASK_TYPES, ACCOUNT_DETAILS, OPPORTUNITY_DETAILS, REMOVE_TASK, UPDATE_TASK, ASSIGNEE, TASK_BY_ID, TASK_LISTING,
    TASK_FILTER
} from "./type";

const initialState = {
    assignee: [],
    getTaskType: [],
    getAccounts: [],
    saveTask: [],
    UpdateTask: [],
    removeTask: [],
    opportunityDetails: [],
    taskDetailsById:[],
    listing:[],
    filter:[]
};

const Task = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case TASK_TYPES:
            return {
                ...state,
                getTaskType: payload,
            };
        case ASSIGNEE:
            return {
                ...state,
                assignee: payload,
            };
        case ACCOUNT_DETAILS:
            return {
                ...state,
                getAccounts: payload,
            };
        case SAVE_TASK:
            return {
                ...state,
                saveTask: payload,
            };
        case OPPORTUNITY_DETAILS:
            return {
                ...state,
                opportunityDetails: payload,
            };
        case REMOVE_TASK:
            return {
                ...state,
                removeTask: payload,
            };
        case UPDATE_TASK:
            return {
                ...state,
                UpdateTask: payload,
            };
        case TASK_BY_ID:
            return {
                ...state,
                taskDetailsById: payload,
            };
        case TASK_LISTING:
            return {
                ...state,
                listing: payload,
            };
        case TASK_FILTER:
            return {
                ...state,
                filter: payload,
            };
        default:
            return {...state};
    }
};

export default Task;